import { PopularDestinations } from 'shared/seo/PopularDestinations';
import flight from '@/components/internalLinks/flight.json';
import hotel from '@/components/internalLinks/hotel.json';
import { InternalLinksSection } from '@/components/internalLinks/InternalLinksSection';
import prepackage from '@/components/internalLinks/prepackage.json';
import { transformDestinations, transformFlightDestinations } from '@/components/internalLinks/transformDestinations';
import data from './data/flight.json';
import { toDestinations } from './toDestinations';

export const CarrentalSeo = () => {
    const flightItems = transformFlightDestinations(flight);
    const prepackageItems = transformDestinations(prepackage, 'pakkereiser');
    const hotelItems = transformDestinations(hotel, 'hotell');

    const cities = toDestinations(data.cities, data.cdnPath, data.basePath, data.altPrefix);
    const countries = toDestinations(data.countries, data.cdnPath, data.basePath, data.altPrefix);

    return (
        <>
            <PopularDestinations heading={data.citiesHeading} destinations={cities} />
            <InternalLinksSection title="Finn flyreiser til populære byer" items={flightItems} />
            <PopularDestinations heading={data.countriesHeading} destinations={countries} />
            <InternalLinksSection title="Finn pakkereiser til spennende steder" items={prepackageItems} />
            <InternalLinksSection title="Finn rimelige hoteller i Europa" items={hotelItems} />
        </>
    );
};
